/**
 * Getters for person
 */
export const getters = {
  getValidated(state) {
    return state.validated;
  },
  getEditPersonId(state) {
    return state.editPersonId;
  },
  getAddOrEditPerson(state) {
    return state.addOrEditPerson;
  }
};
